/**
 * Public barrel export for ActiveFilterChips
 * @module components/shared/search-modal/ActiveFilterChips
 */

export { default } from "./ActiveFilterChipsView";
